import { IClassname } from '@/lib/shared/model/classname';

export const WineCabinet = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.278 17.9173V20.9702C17.2618 21.8755 17.559 22.7586 18.1194 23.4699C18.6797 24.1811 19.4687 24.6768 20.3526 24.873C20.9095 24.9855 21.4844 24.9728 22.0357 24.8359C22.5871 24.6989 23.1011 24.4412 23.5406 24.0813C23.9801 23.7214 24.3342 23.2683 24.5772 22.7548C24.8201 22.2413 24.9459 21.6802 24.9455 21.1121V17.9173C24.9455 17.8334 24.9289 17.7503 24.8968 17.6728C24.8647 17.5952 24.8177 17.5248 24.7583 17.4655C24.699 17.4061 24.6286 17.3591 24.551 17.327C24.4735 17.2948 24.3904 17.2783 24.3065 17.2783H17.9169C17.7475 17.2783 17.5849 17.3456 17.4651 17.4655C17.3453 17.5853 17.278 17.7478 17.278 17.9173Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.1116 24.9453V30.6959"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.917 30.6963H24.3066"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.278 14.5455C17.2779 14.2466 17.173 13.9572 16.9815 13.7276L14.3797 10.6044C14.1883 10.3748 14.0834 10.0854 14.0832 9.78652V2.58163C14.0832 2.2427 13.9486 1.91766 13.7089 1.678C13.4693 1.43835 13.1442 1.30371 12.8053 1.30371H11.5274C11.1885 1.30371 10.8634 1.43835 10.6238 1.678C10.3841 1.91766 10.2495 2.2427 10.2495 2.58163V9.78652C10.2493 10.0854 10.1444 10.3748 9.953 10.6044L7.35116 13.7276C7.15973 13.9572 7.05482 14.2466 7.05469 14.5455V29.4179C7.05469 29.7568 7.18932 30.0818 7.42898 30.3215C7.66864 30.5612 7.99368 30.6958 8.3326 30.6958H15.3611"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2493 5.1377H14.083"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
